import Vue from "vue";
import Router from "vue-router";
import loadjs from "loadjs";
import store from "../store";

/* Router Modules */
import newsRouter from "./modules/news";
import groupBuying from "./modules/groupBuying";

Vue.use(Router);

export const routes = [
  {
    path: "/",
    name: "home",
    hidden: true,
    meta: {
      title: "首页",
      requireAuth: false
    },
    redirect: "/index",
    component: () => import(/* webpackChunkName: "home" */ "@/views/home")
  },
  {
    path: "/index",
    name: "index",
    hidden: true,
    meta: {
      title: "首页",
      // keepAlive: true,
      requireAuth: false
    },
    component: () => import(/* webpackChunkName: "index" */ "@/views/index/index.vue")
  },
  {
    path: "/sd/index",
    name: "sdIndex",
    hidden: true,
    meta: {
      title: "首页",
      keepAlive: true,
      requireAuth: false
    },
    component: () => import(/* webpackChunkName: "sdIndex" */ "@/views/index/index-sd.vue")
  },
  {
    path: "/sd/index",
    name: "sdIndex",
    hidden: true,
    meta: {
      title: "首页",
      keepAlive: true,
      requireAuth: false
    },
    component: () => import(/* webpackChunkName: "sdIndex" */ "@/views/index/index-sd.vue")
  },
  newsRouter,
  {
    path: "/cart",
    name: "cart",
    meta: {
      title: "进货车",
      requireAuth: true
    },
    component: () => import(/* webpackChunkName: "home" */ "@/views/cart")
  },
  {
    path: "/qa",
    name: "qa",
    meta: {
      title: "商品答疑",
      requireAuth: false
    },
    component: () => import(/* webpackChunkName: "qa" */ "@/views/qa/qa")
  },
  {
    path: "/goodDetails/:goodsId",
    name: "goodDetails",
    meta: {
      title: "商品详情",
      // keepAlive: true,
      requireAuth: false
    },
    component: () => import(/* webpackChunkName: "home" */ "@/views/goodDetails")
  },
  {
    path: "/shop/:shopId",
    name: "shop",
    meta: {
      title: "店铺首页",
      keepAlive: true,
      requireAuth: false
    },
    component: () => import(/* webpackChunkName: "home" */ "@/views/shop")
  },
  {
    path: "/goodList",
    name: "goodList",
    meta: {
      requireAuth: false
    },
    component: () => import(/* webpackChunkName: "home" */ "@/views/goodList")
  },
  {
    path: "/confirmOrder",
    name: "confirmOrder",
    meta: {
      requireAuth: true,
      title: "订单提交"
    },
    component: () => import(/* webpackChunkName: "home" */ "@/views/confirmOrder")
  },
  {
    path: "/addressList",
    name: "addressList",
    meta: {
      requireAuth: false,
      title: "地址列表"
    },
    component: () => import(/* webpackChunkName: "home" */ "@/views/addressList")
  },
  {
    path: "/group/goodList",
    name: "groupGoodList",
    meta: {
      requireAuth: false,
      title: "超值中心"
    },
    component: () => import(/* webpackChunkName: "home" */ "@/views/group/goodList")
  },
  {
    path: "/group/myGroup",
    name: "groupGoodList",
    meta: {
      requireAuth: false,
      title: "我的拼团"
    },
    component: () => import(/* webpackChunkName: "home" */ "@/views/group/myGroup")
  },
  {
    path: "/group/groupBook/:goodsId/:activityId",
    name: "groupBook",
    meta: {
      requireAuth: false,
      title: "拼团详情"
    },
    component: () => import(/* webpackChunkName: "home" */ "@/views/group/groupBook")
  },
  {
    path: "/group/myGroupBook",
    name: "groupBook",
    meta: {
      requireAuth: false,
      title: "我的拼团"
    },
    component: () => import(/* webpackChunkName: "home" */ "@/views/group/myGroupBook")
  },
  {
    path: "/group/shareGroupBook",
    name: "groupBook",
    meta: {
      requireAuth: false,
      title: "分享拼团"
    },
    component: () => import(/* webpackChunkName: "home" */ "@/views/group/shareGroupBook")
  },
  {
    path: "/integral",
    name: "integral",
    meta: {
      requireAuth: false,
      title: "积分中心"
    },
    component: () => import(/* webpackChunkName: "integral" */ "@/views/integral")
  },
  {
    path: "/integral/detail",
    name: "integralDetail",
    meta: {
      requireAuth: false,
      title: "积分明细"
    },
    component: () => import(/* webpackChunkName: "integralDetail" */ "@/views/integral/detail")
  },
  {
    path: "/integral/gift",
    name: "integralGift",
    meta: {
      requireAuth: false,
      title: "积分转赠"
    },
    component: () => import(/* webpackChunkName: "integralDetail" */ "@/views/integral/gift")
  },
  {
    path: "/integral/redPacket",
    name: "integralRedPacket",
    meta: {
      requireAuth: false,
      title: "积分领取"
    },
    component: () => import(/* webpackChunkName: "integralDetail" */ "@/views/integral/redPacket")
  },
  {
    path: "/integral/userList",
    name: "integralUserList",
    meta: {
      requireAuth: false,
      title: "赠送对象选择"
    },
    component: () => import(/* webpackChunkName: "integralDetail" */ "@/views/integral/userList")
  },
  {
    path: "/integral/ruleDetail",
    name: "integralRuleDetail",
    meta: {
      requireAuth: false,
      title: "积分规则"
    },
    component: () => import(/* webpackChunkName: "integralDetail" */ "@/views/integral/ruleDetail")
  },
  {
    path: "/integral/my",
    name: "myIntegral",
    meta: {
      requireAuth: false,
      title: "我的积分"
    },
    component: () => import(/* webpackChunkName: "integralDetail" */ "@/views/integral/my")
  },
  {
    path: "/vip/vip",
    name: "vip",
    meta: {
      requireAuth: false,
      title: "注册会员"
    },
    component: () => import(/* webpackChunkName: "vip" */ "@/views/vip/vip.vue")
  },
  {
    path: "/vip/result",
    name: "vipResult",
    meta: {
      requireAuth: false,
      title: "注册会员"
    },
    component: () => import(/* webpackChunkName: "vip" */ "@/views/vip/result.vue")
  },
  {
    path: "/comcart",
    name: "comCart",
    meta: {
      requireAuth: false,
      title: "常用车辆"
    },
    component: () => import(/* webpackChunkName: "comCart" */ "@/views/comCart/index.vue")
  },
  {
    path: "/comcart/add",
    name: "comCartAdd",
    meta: {
      requireAuth: false,
      title: "新增车辆"
    },
    component: () => import(/* webpackChunkName: "comCartAdd" */ "@/views/comCart/add.vue")
  },
  {
    path: "/znt/good/list",
    name: "zntGoodList",
    meta: {
      requireAuth: true,
      title: "优品"
    },
    component: () => import(/* webpackChunkName: "zntGoodList" */ "@/views/znt/goodList")
  },
  {
    path: "/znt/shop/list",
    name: "zntShopList",
    meta: {
      requireAuth: true,
      title: "好店"
    },
    component: () => import(/* webpackChunkName: "zntShopList" */ "@/views/znt/shopList")
  },
  {
    path: "/authorization/index",
    name: "authorization",
    meta: {
      requireAuth: false,
      title: "授权成功"
    },
    component: () =>
      import(/* webpackChunkName: "authorization" */ "@/views/authorization/index.vue")
  },
  {
    path: "/buyer/address/addAddr",
    name: "addAddr",
    meta: {
      requireAuth: false,
      title: "新增地址"
    },
    component: () =>
      import(/* webpackChunkName: "home" */ "@/views/address/buyer/addAddr/index.vue")
  },
  {
    path: "/seller/address/addAddr",
    name: "addAddr",
    meta: {
      requireAuth: false,
      title: "新增地址"
    },
    component: () =>
      import(/* webpackChunkName: "home" */ "@/views/address/seller/addAddr/index.vue")
  },
  {
    path: "/selfAddr",
    name: "selfAddr",
    meta: {
      requireAuth: false,
      title: "自提人列表"
    },
    component: () => import(/* webpackChunkName: "selfAddr" */ "@/views/selfAddr/index.vue")
  },
  {
    path: "/selfAddr/add",
    name: "selfAddrAdd",
    meta: {
      requireAuth: false,
      title: "新增自提人"
    },
    component: () => import(/* webpackChunkName: "selfAddrAdd" */ "@/views/selfAddr/add.vue")
  },
  {
    path: "/categories",
    name: "categories",
    meta: {
      keepAlive: true,
      requireAuth: false,
      title: "分类"
    },
    component: () => import(/* webpackChunkName: "categories" */ "@/views/categories/index.vue")
  },
  {
    path: "/channel/shop",
    name: "channelShop",
    meta: {
      requireAuth: false,
      title: ""
    },
    // component: () => import(/* webpackChunkName: "channelShop" */ "@/views/channelShop/index.vue")
    component: () =>
      import(/* webpackChunkName: "channelShopNew" */ "@/views/channelShop/indexNew.vue")
  },
  {
    path: "/channel/shop/vip",
    name: "channelShopVip",
    meta: {
      requireAuth: false,
      keepAlive: true,
      title: "养殖会员"
    },
    // component: () =>
    //   import(/* webpackChunkName: "channelShopVip" */ "@/views/channelShop/vip/index.vue")
    component: () =>
      import(/* webpackChunkName: "channelShopNew" */ "@/views/channelShop/indexNew.vue")
  },
  {
    path: "/order/pickup",
    name: "orderPickUp",
    meta: {
      requireAuth: false,
      title: "确认自提"
    },
    component: () => import(/* webpackChunkName: "orderPickUp" */ "@/views/order/pickup/index.vue")
  },
  {
    path: "/order/credential",
    name: "orderCredential",
    meta: {
      requireAuth: false,
      title: "查看凭证"
    },
    component: () =>
      import(/* webpackChunkName: "orderCredential" */ "@/views/order/credential/index.vue")
  },
  {
    path: "/order/logistics",
    name: "orderLogistics",
    meta: {
      requireAuth: false,
      keepAlive: true,
      title: "查看物流"
    },
    component: () =>
      import(/* webpackChunkName: "orderLogistics" */ "@/views/order/logistics/index.vue")
  },
  {
    path: "/order/confirmation",
    name: "orderConfirmation",
    meta: {
      requireAuth: true,
      title: "确认收货"
    },
    component: () =>
      import(/* webpackChunkName: "orderConfirmation" */ "@/views/order/confirmation/index.vue")
  },
  {
    path: "/403",
    name: "403",
    meta: {
      requireAuth: false,
      title: "确认自提"
    },
    component: () => import(/* webpackChunkName: "orderPickUp" */ "@/views/order/pickup/index.vue")
  },
  {
    path: "/order/credential",
    name: "orderCredential",
    meta: {
      requireAuth: false,
      title: "查看凭证"
    },
    component: () =>
      import(/* webpackChunkName: "orderCredential" */ "@/views/order/credential/index.vue")
  },
  {
    path: "/order/logistics",
    name: "orderLogistics",
    meta: {
      requireAuth: false,
      keepAlive: true,
      title: "查看物流"
    },
    component: () =>
      import(/* webpackChunkName: "orderLogistics" */ "@/views/order/logistics/index.vue")
  },
  {
    path: "/treaty/paymentOnBehalfTreaty",
    name: "代付协议",
    hidden: true,
    component: () =>
      import(/* webpackChunkName: "deposit" */ "@/views/treaty/paymentOnBehalfTreaty/index.vue")
  },
  {
    path: "/signature",
    name: "signature",
    meta: {
      requireAuth: true,
      title: "签收单详情"
    },
    component: () => import(/* webpackChunkName: "signature" */ "@/views/signature/index.vue")
  },
  {
    path: "/signature/detail",
    name: "signature",
    meta: {
      requireAuth: false,
      title: "签收单详情"
    },
    component: () => import(/* webpackChunkName: "signature" */ "@/views/signature/detail.vue")
  },
  {
    path: "/signature/list",
    name: "signatureList",
    meta: {
      requireAuth: true,
      title: "代收货列表"
    },
    component: () => import(/* webpackChunkName: "signature" */ "@/views/signature/list.vue")
  },
  {
    path: "/distribution",
    name: "distribution",
    meta: {
      requireAuth: true,
      title: "推荐返利"
    },
    component: () => import(/* webpackChunkName: "signature" */ "@/views/distribution/index.vue")
  },
  {
    path: "/replace/voucher",
    name: "replaceVoucher",
    meta: {
      requireAuth: true,
      title: "上传凭证"
    },
    component: () => import(/* webpackChunkName: "signature" */ "@/views/replaceVoucher/index.vue")
  },
  {
    path: "/signature/sign",
    name: "eleSign",
    meta: {
      requireAuth: true,
      title: "电子签收单"
    },
    component: () =>
      import(/* webpackChunkName: "signature" */ "@/views/signature/eleSign/index.vue")
  },
  {
    path: "/ywb",
    name: "",
    meta: {
      requireAuth: true,
      title: "业务战报"
    },
    component: () => import(/* webpackChunkName: "ywb" */ "@/views/ywb/ywb.vue")
  },
  ...groupBuying,
  {
    path: "/403",
    name: "403",
    meta: {
      title: "403页面",
      icon: "el-icon-unlock"
    },
    component: () => import(/* webpackChunkName: "exception" */ "@/views/exception/403")
  },
  {
    path: "/500",
    name: "500",
    meta: {
      title: "500页面",
      icon: "el-icon-bicycle"
    },
    component: () => import(/* webpackChunkName: "exception" */ "@/views/exception/500")
  },
  {
    path: "/404",
    name: "404",
    meta: {
      title: "404页面",
      icon: "el-icon-circle-close"
    },
    component: () => import(/* webpackChunkName: "exception" */ "@/views/exception/404")
  },
  {
    path: "*",
    name: "404All",
    hidden: true,
    component: () => import(/* webpackChunkName: "exception" */ "@/views/exception/404")
  }
];

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach(async (to, from, next) => {
  console.log(to);
  loadjs("https://static.nxin.com/tongji/statistics_nxsc.nxin.com.js");
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  if (to.meta.requireAuth) {
    // 判断该路由是否需要登录权限
    await store.dispatch("app/getUserInfo").then(() => {
      const { userInfo } = store.state.app;
      console.log(userInfo);
      if (userInfo.id) {
        console.log("已经登录无需再登录");
        next();
      } else {
        console.log("需要登录");
        const { shareBoId } = to.query;
        if (shareBoId) {
          sessionStorage.setItem("groupBuyingShareBoId", shareBoId);
        }
        window.location = `${process.env.VUE_APP_M}account/login/sms?service=${
          process.env.VUE_APP_SC
        }&systemId=20&retUrl=${encodeURIComponent(`${process.env.VUE_APP_SC}vm${to.fullPath}`)}`;
      }
    });
  } else {
    console.log("不需要登录");
    await store.dispatch("app/getUserInfo").then(() => {
      next();
    });
  }
});

export default router;
